import {
  GROUP_MARGIN_HEIGHT,
  GROUP_MARGIN_WIDTH,
  GROUP_TEXT_HEIGHT_PADDING,
  GraphConverter,
  NODE_DEFAULT_HEIGHT,
  NODE_DEFAULT_WIDTH,
} from "@store/services/converter/graphConverter"
import { GraphNodeEdgeData } from "@store/services/converter/types"
import { GraphStoreType } from "@features/graph/Graph"
import { deepCopy } from "@features/graph/utils/graphUtils"
import { getBoundsOfRects } from "@xyflow/system"

export const graphGroupExpandAll = (graphData: GraphNodeEdgeData, flowStore: GraphStoreType) => {
  const { nodeInternals } = flowStore.getState()

  const nodeCopy = deepCopy(graphData.nodeMap)
  for (const [id, data] of Object.entries(nodeCopy)) {
    if (nodeInternals.has(id)) {
      continue
    }
    const position = {
      x: Math.round(data.position.x),
      y: Math.round(data.position.y),
    }
    nodeInternals.set(id, {
      id,
      type: data.type,
      data,
      position,
      style: {
        width: NODE_DEFAULT_WIDTH,
        height: NODE_DEFAULT_HEIGHT,
      },
      zIndex: data.zIndex,
    })
  }

  const groupCopy = deepCopy(graphData.groupMap)
  for (const [id, data] of Object.entries(groupCopy)) {
    let rect = { ...data.position, width: NODE_DEFAULT_WIDTH, height: NODE_DEFAULT_HEIGHT }
    // Calculate groups size from child nodes
    data.group.nodes.forEach((nodeId) => {
      const node = nodeInternals.get(nodeId)
      if (!node) {
        return
      }
      rect = getBoundsOfRects(rect, {
        ...node.position,
        width: NODE_DEFAULT_WIDTH,
        height: NODE_DEFAULT_HEIGHT,
      })
    })
    data.group.isCollapsed = false
    const position = {
      x: Math.round(rect.x),
      y: Math.round(rect.y),
    }
    if (nodeInternals.has(id)) {
      const node = nodeInternals.get(id)
      if (!node) {
        continue
      }
      node.data.group.isCollapsed = false
      node.position.x = Math.round(rect.x) - GROUP_MARGIN_WIDTH
      node.position.y = Math.round(rect.y) - GROUP_MARGIN_HEIGHT
      node.style!.width = Math.round(rect.width) + GROUP_MARGIN_WIDTH * 2
      node.style!.height =
        Math.round(rect.height) + GROUP_MARGIN_HEIGHT * 2 + GROUP_TEXT_HEIGHT_PADDING
    } else {
      nodeInternals.set(id, {
        id,
        type: "group",
        data,
        position: {
          x: position.x - GROUP_MARGIN_WIDTH,
          y: position.y - GROUP_MARGIN_HEIGHT,
        },
        style: {
          backgroundColor: data.group.color,
          color: "#000",
          width: Math.round(rect.width) + GROUP_MARGIN_WIDTH * 2,
          height: Math.round(rect.height) + GROUP_MARGIN_HEIGHT * 2 + GROUP_TEXT_HEIGHT_PADDING,
        },
        zIndex: data.zIndex,
      })
    }
  }

  const edges = GraphConverter.convertEdges(graphData.zIndex, graphData.nodeMap, nodeInternals)
  flowStore.setState({ nodeInternals, edges })
}
